import { render, staticRenderFns } from "./CsrFootballClinic.vue?vue&type=template&id=719714f0&scoped=true"
import script from "./CsrFootballClinic.vue?vue&type=script&lang=js"
export * from "./CsrFootballClinic.vue?vue&type=script&lang=js"
import style0 from "./CsrFootballClinic.vue?vue&type=style&index=0&id=719714f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719714f0",
  null
  
)

export default component.exports